<script lang="ts">
export default {
    name: 'BaseBreadcrumbsItem',
};
</script>

<script setup lang="ts">
import { BaseBreadcrumbs } from '@/components/base-components/components/breadcrumbs/context';
import { requireInject } from '@/components/base-components/utils/require-inject';

defineProps<{
    label?: string | number;
}>();

const { divider } = requireInject(BaseBreadcrumbs);
</script>

<template>
    <div class="flex items-center group">
        <slot>
            <span class="truncate">
                {{ label }}
            </span>
        </slot>

        <base-breadcrumbs-divider
            class="group-last:hidden"
            :divider="divider"
        />
    </div>
</template>
